import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBorderNone, faCamera, faCheck, faFileExcel, faInfo, faSort} from '@fortawesome/free-solid-svg-icons';
import {Badge, Button, Card, Col, Dropdown, Row, Table} from '@themesberg/react-bootstrap';
import BasePage from "./../base/BasePage";
import label from "enqc-utilities/src/label/Label"
import PaginationTable from "../../components/PaginationTable";
import {getUser} from "../../utils/StorageUtil";
import {Link} from "react-router-dom";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import queryString from 'query-string';
import {cloneObject, isImageExists, parseDate} from "enqc-utilities/src/utils/Utilities";
import {DD_MMMM_YYYY_HH_MM_SS} from "../../utils/Global";
import SearchInput from "../../components/input/SearchInput";
import SortOption from "enqc-utilities/src/model/SortOption";
import MyImage from "../../components/MyImage";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import GoodsItemDetailPage from "./GoodsItemDetailPage";
import SmartDeviceInfoModal from "../../components/SmartDeviceInfoModal";
import GoodsInfoViewModal from "../../components/GoodsInfoViewModal";

class StockInfoPage extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            inputSearch: queryString.parse(this.props.query).search ? queryString.parse(this.props.query).search : "",
            user : getUser(),
            selectedGoodsInfo:undefined,
            createGoodsItemModal:{
                show:false,
                position:-1,
                goodsInfo:{},
                goodsItems:[],
            },
            goodsItemImageModal:{
                show:false,
                position:-1,
                goodsItem:{},
            },
            categorySelectorModal:false,
            page: queryString.parse(props.query).page ? queryString.parse(props.query).page : 1,
            goodsInfos:[],
            goodsItemStatutes:[],
            selectedGoodsItemStatus:{},
            goodsCategories:[],
            selectedGoodCategories:[],
            selectedGoodsInfos:[],
            selectedSmartDeviceFilter:{},
            selectedSmartDeviceInfo:{},
            smartDevices:[],
            goodsItems:[],
            goodsInfo:{},
            totalPage: 0,
            totalElement: 0,
            pageElement: 0,
            sortOption:SortOption.init(label.Oldest,"gi.created",true)
        }
    }

    componentDidMount() {
        super.componentDidMount();
        if(this.props?.navBar?.current){
            this.props.navBar.current.updateNavBarItems([StockInfoPage.PAGE_CONF])
        }

        this.closePreLoader()
        this.fetchSmartDeviceList()
        this.fetchGoodsItemStatusList()
        this.fetchGoodsCategoryList()
        this.fetchGoodsInfoList()
        this.fetchGoodsItemList()
    }

    componentWillReceiveProps(props, nextContext) {
        if (props != this.props) {
            let page = queryString.parse(props.query).page ? queryString.parse(props.query).page : 1
            let key = queryString.parse(props.query).tab ? queryString.parse(props.query).tab : label.All
            let inputSearch = queryString.parse(props.query).search ? queryString.parse(props.query).search : ""
            this.setState({
                page: page,
                key: key,
                inputSearch: inputSearch
            }, () => {
                this.fetchGoodsInfoList()
            })
        }
    }

    fetchSmartDeviceList = () => {
        let {selectedSmartDeviceFilter} = this.state
        this.get(Endpoint.API.SMART_DEVICES, {
            params :{
                smartDeviceTypeString:"toolbox",
                ascending: false,
                sortir: "jt.created",
            }
        }, null, response=>{
            if(response.code===200){
                let smartDevices = response.data
                let defaultSmartDevice = {id:0, deviceId:label.AllDevices, localIpAddress:'0.0.0.0'}
                selectedSmartDeviceFilter = defaultSmartDevice
                smartDevices.unshift(defaultSmartDevice)
                this.setState({smartDevices:smartDevices, selectedSmartDeviceFilter})
            }else{
                this.props.history.goBack();
            }
        }, false, true)
    }


    fetchGoodsItemStatusList(){
        let {goodsItemStatutes, sortOption, search, selectedGoodsInfos, selectedSmartDeviceFilter, selectedGoodCategories, selectedGoodsItemStatus, goodsInfoId} = this.state
        let goodsCategoryIdStrings = ""
        if(selectedGoodCategories){
            selectedGoodCategories.forEach((goodCategory, index)=>{
                if(goodCategory.id!==0){
                    if(index!==0) {
                        goodsCategoryIdStrings += ","
                    }
                    goodsCategoryIdStrings += goodCategory.id
                }
            })
        }

        let goodsInfoIds = []
        if(selectedGoodsInfos){
            selectedGoodsInfos.forEach((goodsInfo, index)=>{
                if(goodsInfo.id && goodsInfo.id!==0){
                    goodsInfoIds.push(goodsInfo.id)
                }
            })
        }
        let selectedGoodsItemStatusId = undefined
        if(selectedGoodsItemStatus.id && selectedGoodsItemStatus.id!==0){
            selectedGoodsItemStatusId = selectedGoodsItemStatus.id
        }

        let filteredSmartDeviceIdStrings = "[]"
        if(selectedSmartDeviceFilter.id && selectedSmartDeviceFilter.id!==0){
            filteredSmartDeviceIdStrings = "["+selectedSmartDeviceFilter.id+"]"
        }

        this.get(Endpoint.API.GOODS_ITEM_STATUSES_ITEM_COUNT, {
            params :{
                filteredGoodsCategoryIdStrings:goodsCategoryIdStrings,
                filteredGoodsInfoIdStrings:JSON.stringify(goodsInfoIds),
                ascending: true,
                sortir: "id",
                search:search
            }
        }, null, response=>{
            if(response.code===200){
                let goodsItemStatutes = response.data
                let defaultGoodsItemStatus = {id:0, label:label.AllStatuses}
                if(selectedGoodsItemStatus.id!==0) {
                    selectedGoodsItemStatus = defaultGoodsItemStatus
                }
                goodsItemStatutes.unshift(defaultGoodsItemStatus)
                this.setState({goodsItemStatutes:goodsItemStatutes, selectedGoodsItemStatus})
            }else{
                this.props.history.goBack();
            }
        }, false, true)
    }

    fetchGoodsCategoryList(){
        let {goodsCategory, sortOption, selectedGoodCategories, search} = this.state
        this.get(Endpoint.API.GOODS_CATEGORIES, {
            params :{
                ascending: true,
                sortir: "name",
                search:search
            }
        }, null, response=>{
            if(response.code===200){
                let goodsCategories = response.data
                let defaultCategory = {id:0, name:label.AllCategories}
                selectedGoodCategories.push(defaultCategory)
                goodsCategories.unshift(defaultCategory)
                this.setState({goodsCategories:goodsCategories, selectedGoodCategories})
            }else{
                this.props.history.goBack();
            }
        }, false, true)
    }

    fetchGoodsInfoList = () => {
        let {user, selectedGoodCategories, selectedGoodsInfos, goodsInfos, search, sortOption} = this.state
        let goodsCategoryIdStrings = ""
        if(selectedGoodCategories){
            selectedGoodCategories.forEach((goodCategory, index)=>{
                if(goodCategory.id!==0){
                    if(index!==0) {
                        goodsCategoryIdStrings += ","
                    }
                    goodsCategoryIdStrings += goodCategory.id
                }
            })
        }
        this.get(Endpoint.API.GOODS_INFOS, {
            params :{
                userId : user.id,
                goodsCategoryIdStrings:goodsCategoryIdStrings,
                ascending: true,
                sortir: "gi.name",
            }
        }, null, response=>{
            if(response.code===200){
                let goodsInfos = response.data
                if(goodsInfos.length>0){
                    let defaultGoodsInfo = {id:0, name:label.AllGoods}
                    selectedGoodsInfos.push(defaultGoodsInfo)
                    goodsInfos.unshift(defaultGoodsInfo)
                }
                this.setState({goodsInfos:goodsInfos, selectedGoodsInfos}, () => this.fetchGoodsItemList())
            }else{
                this.props.history.goBack();
            }
        }, false, true)
    }

    fetchGoodsItemList = async (downloadExcel) => {
        let {user,goodsItems, search, selectedGoodsInfos, selectedSmartDeviceFilter, selectedGoodCategories, selectedGoodsItemStatus, goodsInfoId} = this.state

        let goodsCategoryIdStrings = ""
        if(selectedGoodCategories){
            selectedGoodCategories.forEach((goodCategory, index)=>{
                if(goodCategory.id!==0){
                    if(index!==0) {
                        goodsCategoryIdStrings += ","
                    }
                    goodsCategoryIdStrings += goodCategory.id
                }
            })
        }

        let goodsInfoIds = []
        if(selectedGoodsInfos){
            selectedGoodsInfos.forEach((goodsInfo, index)=>{
                if(goodsInfo.id && goodsInfo.id!==0){
                    goodsInfoIds.push(goodsInfo.id)
                }
            })
        }
        let selectedGoodsItemStatusId = undefined
        if(selectedGoodsItemStatus.id && selectedGoodsItemStatus.id!==0){
            selectedGoodsItemStatusId = selectedGoodsItemStatus.id
        }

        let filteredSmartDeviceIdStrings = "[]"
        if(selectedSmartDeviceFilter.id && selectedSmartDeviceFilter.id!==0){
            filteredSmartDeviceIdStrings = "["+selectedSmartDeviceFilter.id+"]"
        }
        let params = {
            params :{
                "goodsInfoId":goodsInfoId,
                filteredGoodsCategoryIdStrings:goodsCategoryIdStrings,
                filteredGoodsInfoIdStrings:JSON.stringify(goodsInfoIds),
                filteredSmartDeviceIdStrings:filteredSmartDeviceIdStrings,
                goodsItemStatusId:selectedGoodsItemStatusId,
                ascending: true,
                sortir: "gi.rfidTag",
                search: search,
                page: this.state.page - 1,
            }
        }
        if(downloadExcel){
            await this.asyncDownloadGet(Endpoint.API.GOODS_ITEMS_DOWNLOAD_EXCEL, params, null, false, false)
        }else{
            this.get(Endpoint.API.GOODS_ITEMS, params, null, response=>{
                if(response.code===200){
                    let goodsItems = response.data
                    let totalPage = response.totalPage
                    let totalElement = response.totalElement
                    let pageElement = response.pageElement
                    this.setState({goodsItems:goodsItems,totalPage, totalElement, pageElement})
                }else{
                    this.props.history.goBack();
                }
            }, false, true)
        }
    }


    selectCategories(goodCategory, clear){
        let {goodsCategories, selectedGoodCategories} = this.state
        if(clear){
            selectedGoodCategories = []
            selectedGoodCategories.push(goodCategory)
            this.setState({selectedGoodCategories, selectedGoodsInfos:[]}, () => {
                this.fetchGoodsItemStatusList()
                this.fetchGoodsInfoList()})
            return;
        }
        selectedGoodCategories = selectedGoodCategories.filter(gc => {
            return gc.id !== 0
        });
        const exists = selectedGoodCategories.some(gc => goodCategory.id === gc.id);
        if(exists){
            const updatedSelectedGoodsCategories = selectedGoodCategories.filter(gc => {
                return goodCategory.id !== gc.id
            });
            this.setState({selectedGoodCategories:updatedSelectedGoodsCategories, selectedGoodsInfos:[]}, () => {
                this.fetchGoodsItemStatusList()
                this.fetchGoodsInfoList()
            })
        }else{
            selectedGoodCategories.push(goodCategory)
            this.setState({selectedGoodCategories, selectedGoodsInfos:[]}, () => {
                this.fetchGoodsItemStatusList()
                this.fetchGoodsInfoList()
            })
        }
    }

    selectAllCategories(){
        let {goodsCategories, selectedGoodCategories} = this.state
        selectedGoodCategories = []
        selectedGoodCategories.push(goodsCategories[0])
        this.setState({selectedGoodCategories, selectedGoodsInfos:[]}, () => {
            this.fetchGoodsInfoList()
        })
        return;
    }

    goodCategoryExists(goodCategory){
        let {selectedGoodCategories} = this.state
        const exists = selectedGoodCategories.some(gc => goodCategory.id === gc.id);
        return exists;
    }

    selectGoodsInfos(goodsInfo, clear){
        let {goodsInfos, selectedGoodsInfos} = this.state
        // if(0)
        if(clear){
            selectedGoodsInfos = []
            selectedGoodsInfos.push(goodsInfo)
            this.setState({selectedGoodsInfos}, () => {
                this.fetchGoodsItemStatusList()
                this.fetchGoodsItemList()
            })
            return;
        }
        selectedGoodsInfos = selectedGoodsInfos.filter(gi => {
            return gi.id !== 0
        });
        const exists = selectedGoodsInfos.some(gi => goodsInfo.id === gi.id);
        if(exists){
            const updatedSelectedGoodsInfos = selectedGoodsInfos.filter(gc => {
                return goodsInfo.id !== gc.id
            });
            this.setState({selectedGoodsInfos:updatedSelectedGoodsInfos}, () => {
                this.fetchGoodsItemStatusList()
                this.fetchGoodsItemList()
            })
        }else{
            selectedGoodsInfos.push(goodsInfo)
            this.setState({selectedGoodsInfos}, () => {
                this.fetchGoodsItemStatusList()
                this.fetchGoodsItemList()
            })
        }
    }

    selectAllGoodsInfos(){
        let {goodsInfos, selectedGoodsInfos} = this.state
        selectedGoodsInfos = []
        selectedGoodsInfos.push(goodsInfos[0])
        this.setState({selectedGoodsInfos}, () => {
            this.fetchGoodsItemStatusList()
            this.fetchGoodsItemList()
        })
        return;
    }


    goodInfoExists(goodsInfo){
        let {selectedGoodsInfos} = this.state
        const exists = selectedGoodsInfos.some(gc => goodsInfo.id === gc.id);
        return exists;
    }


    render() {
        let {user, smartDevices, goodsInfos, goodsCategories, goodsItems,
            goodsItemStatutes, selectedGoodsItemStatus, goodsItemImageModal,
            selectedSmartDeviceInfo,selectedSmartDeviceFilter,
            page, pageElement, totalPage, totalElement, sortOption,
            selectedGoodsInfo, createGoodsItemModal, categorySelectorModal} = this.state
        return (
            <>
                {super.render()}
                <GoodsInfoViewModal
                    show={selectedGoodsInfo!==undefined}
                    goodsInfo={selectedGoodsInfo}
                    onClose={() => {
                        this.setState({selectedGoodsInfo:undefined})
                    }}
                    showProcessing={this.props.showProcessing}
                    closeProcessing={this.props.closeProcessing}
                />

                <SmartDeviceInfoModal {...this.props}
                    onClose={() => {
                        this.setState({selectedSmartDeviceInfo:{}})
                    }}
                    show={selectedSmartDeviceInfo.id}
                    smartDevice={selectedSmartDeviceInfo}/>
                <Row>
                    <Col md={2} className="m-0 pe-0">
                        <Card border="light" className="table-wrapper table-responsive shadow-sm" style={{height:'100vh'}}>
                            <Card.Header className="p-3 border-bottom border-1 border-soft-green">
                                <Row>
                                    <Col>
                                        {label.Category}
                                    </Col>
                                    <Col className="text-right bold">
                                        #{goodsCategories.length-1}
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body className="p-0">
                                <Table size="sm" hover>
                                    <tbody>
                                    {
                                        goodsCategories.map((item, index)=>(
                                            <tr
                                                span={1} style={{cursor:'pointer'}}
                                                className={"px-2 "+(this.goodCategoryExists(item)?"bg-gradient-gray-500":"")}
                                                onClick={e =>{
                                                    if(index!==0){
                                                        if(e.ctrlKey || e.metaKey){
                                                            this.selectCategories(item)
                                                        }else{
                                                            this.selectCategories(item, true)
                                                        }
                                                    }else{
                                                        this.selectAllCategories()
                                                    }
                                                }}
                                            >
                                                <td className="px-2">{index+1}.</td>
                                                <td className="px-0 text-wrap">{item.name}</td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={2} className="m-0 ps-0">
                        <Card border="light" className="table-wrapper table-responsive shadow-sm" style={{height:'100vh'}}>
                            <Card.Header className="p-3 border-bottom border-1 border-soft-green">
                                <Row>
                                    <Col>
                                        {label.GoodsList}
                                    </Col>
                                    <Col className="text-right bold">
                                        #{goodsInfos.length>0?goodsInfos.length-1:0}
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body className="p-0">
                                <Table size="sm" hover>
                                    <tbody>
                                    {
                                        goodsInfos.length>0?(
                                                goodsInfos.map((item, index)=>(
                                                    <tr
                                                        span={1} style={{cursor:'pointer'}}
                                                        className={"px-2 "+(this.goodInfoExists(item)?"bg-gradient-gray-500":"")}
                                                        onClick={e =>{
                                                            if(index!==0){
                                                                if(e.ctrlKey || e.metaKey){
                                                                    this.selectGoodsInfos(item)
                                                                }else{
                                                                    this.selectGoodsInfos(item, true)
                                                                }
                                                            }else{
                                                                this.selectAllGoodsInfos()
                                                            }
                                                        }}
                                                    >
                                                        <td className="px-2">{index+1}.</td>
                                                        <td className="px-0 text-wrap">{item.name}</td>
                                                        <td className="text-right pe-2">
                                                            {index!==0&&(
                                                                <Button
                                                                    variant="outline-success"
                                                                    className="p-0" size="sm"
                                                                    style={{width:'21px', height:'21px'}}
                                                                    onClick={event => {
                                                                        this.setState({selectedGoodsInfo:item})
                                                                    }}>
                                                                    <FontAwesomeIcon size="sm" className="super-badge m-0" icon={faInfo}/>
                                                                </Button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))
                                            ):
                                            (
                                                <tr className="px-2">
                                                    <td className="px-2 text-center border-0">No Item available..</td>
                                                </tr>
                                            )
                                    }
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={8}>
                        <div className="table-settings mb-3">
                            <Row className="align-items-center mb-3">
                                <Col md={4}>
                                    <Dropdown size="sm">
                                        <Dropdown.Toggle
                                            size="sm"
                                            variant="outline-success" id="dropdown-basic">
                                            {selectedGoodsItemStatus.label}&nbsp;&nbsp;<FontAwesomeIcon icon={faSort}/>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="p-0 fs-7">
                                            {goodsItemStatutes.map((item, index)=>(
                                                <>
                                                    <Dropdown.Item className="px-2 py-2 fs-7" href="#" onClick={event => {
                                                        this.setState({selectedGoodsItemStatus:item}, () => {
                                                            // this.fetchGoodsItemStatusList()
                                                            this.fetchGoodsItemList()
                                                        })
                                                    }}>
                                                        <Row>
                                                            <Col>
                                                                {item.label}
                                                            </Col>
                                                            <Col className="text-right">
                                                                <MyImage src={item.iconLink} style={{width:'18px'}} />
                                                            </Col>
                                                        </Row>
                                                    </Dropdown.Item>
                                                    <Dropdown.Divider className="m-0"/>
                                                </>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                                <Col md={4}className="ps-md-0 text-right">
                                </Col>
                                <Col md={4}>
                                    <SearchInput onEnter={(search) => {
                                        this.setState({search}, () => {
                                            this.fetchGoodsItemStatusList()
                                            this.fetchGoodsItemList()
                                        })
                                    }} onEmpty={() => {
                                        this.setState({search:""},() => {
                                            this.fetchGoodsItemStatusList()
                                            this.fetchGoodsItemList()
                                        })
                                    }}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={8}>
                                    <Row className="align-items-center">
                                        <Col md={2}>
                                            <Button size="sm" variant="outline-light" style={{background:'black', pointerEvents:'none'}}>
                                                {label.All}&nbsp;&nbsp;<Badge bg="white" className="text-black" style={{fontSize:'12px'}}>{totalElement}</Badge>
                                            </Button>
                                        </Col>
                                        {
                                            goodsItemStatutes.map((item, index)=> (
                                                    item.itemCount>0&&(
                                                        <Col md={2}>
                                                            <Button size="sm" variant="outline-light" style={{background:item.color, pointerEvents:'none'}}>
                                                                {item.label}&nbsp;&nbsp;<Badge bg="white" className="text-black" style={{fontSize:'12px'}}>{item.itemCount}</Badge>
                                                            </Button>
                                                        </Col>
                                                    )
                                            ))
                                        }
                                    </Row>
                                </Col>
                                <Col md={4} className="text-right">
                                    <Dropdown size="sm" className="text-right" alignRight={true} drop="down">
                                        <Dropdown.Toggle
                                            size="sm"
                                            variant="outline-info" id="dropdown-basic">
                                            {selectedSmartDeviceFilter.deviceId}&nbsp;-&nbsp;{selectedSmartDeviceFilter.localIpAddress}&nbsp;<FontAwesomeIcon icon={faSort}/>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu align={"right"} alignRight={true} md={"right"} className="p-0 fs-7 force-bottom-dropdown" style={{right:'unset !important'}}>
                                            {smartDevices.map((item, index)=>(
                                                <>
                                                    <Dropdown.Item className="px-2 py-2 fs-7" href="#" onClick={event => {
                                                        this.setState({selectedSmartDeviceFilter:item}, () => {
                                                            this.fetchGoodsItemStatusList()
                                                            this.fetchGoodsItemList()
                                                        })
                                                    }}>
                                                        <Row>
                                                            <Col>
                                                                {item.deviceId} - {item.localIpAddress}
                                                            </Col>
                                                            <Col className="text-right">
                                                                <MyImage src={ApplicationIcons.Icons.cabinet} style={{width:'18px'}} />
                                                            </Col>
                                                        </Row>
                                                    </Dropdown.Item>
                                                    <Dropdown.Divider className="m-0"/>
                                                </>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                            </Row>
                        </div>
                        <Card border="light" className="table-wrapper table-responsive shadow-sm">
                            <Card.Body className="p-0">
                                <Table size="sm" hover className="table-sm align-items-center">
                                    <thead>
                                    <tr>
                                        <th className="border-bottom">#</th>
                                        <th className="border-bottom">{label.RFIDTag}</th>
                                        <th className="border-bottom text-center">{label.Image}</th>
                                        <th className="border-bottom">{label.Status}</th>
                                        <th className="border-bottom">{label.LastAllocation}</th>
                                        <th className="border-bottom text-center">{label.LastUpdate}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {goodsItems.map((goodsItem, index) => (
                                        <tr className={(goodsItem.isNew?"yellow-background-blinking":"")+" "+(goodsItem.isDuplicate?"red-background-blinking":"")}>
                                            <td>
                                                {(index+1)}
                                            </td>
                                            <td>
                                                <Card.Link as={Link} to={GoodsItemDetailPage.ENDPOINT+"/"+goodsItem.id} className="fw-normal">
                                                    <span className="fw-normal text-underline">{goodsItem.rfidTag}</span>
                                                </Card.Link>
                                            </td>
                                            <td className="text-center">
                                                <Button
                                                    size="sm"
                                                    variant={isImageExists(goodsItem)?"outline-info":"outline-warning"}
                                                    onClick={event => {
                                                        goodsItemImageModal = {
                                                            ...goodsItemImageModal, position:index, goodsItem:cloneObject(goodsItem), show:true
                                                        }
                                                        this.setState({goodsItemImageModal})
                                                    }}>
                                                    <FontAwesomeIcon icon={faCamera}/>
                                                    &nbsp;
                                                    &nbsp;
                                                    <FontAwesomeIcon icon={isImageExists(goodsItem)?faCheck:faBorderNone}/>
                                                </Button>
                                            </td>
                                            <td>
                                                <span className="fw-normal" style={{color:goodsItem.goodsItemStatus.color}}>{goodsItem.goodsItemStatus.label}</span>
                                            </td>
                                            <td>
                                                <Button
                                                    size="sm"
                                                    variant={goodsItem.lastSmartDeviceLocation?"outline-primary":"outline-danger"}
                                                    className="fw-normal p-1 font-small btn-outline-white"
                                                    onClick={event => {
                                                        this.setState({selectedSmartDeviceInfo:goodsItem.lastSmartDeviceLocation})
                                                    }}
                                                    style={{color:goodsItem.goodsItemStatus.color, borderColor:goodsItem.goodsItemStatus.color}}>
                                                    <MyImage src={goodsItem.goodsItemStatus.insideMachine?ApplicationIcons.Icons.allocatedGreen:ApplicationIcons.Icons.notAllocated} style={{width:'18px'}} />&nbsp;
                                                    {goodsItem.lastSmartDeviceLocation?goodsItem.lastSmartDeviceLocation.deviceId:label.NotYetAllocated}
                                                </Button>
                                            </td>
                                            <td className="text-center">
                                                <span className="fw-normal">{parseDate(goodsItem.updated, DD_MMMM_YYYY_HH_MM_SS)}</span>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </Card.Body>
                            <Row className="p-0 m-0">
                                <Col className="p-0 m-0" md={10}>
                                    <PaginationTable
                                        onSelect={() => {
                                            this.fetchGoodsItemStatusList()
                                            this.fetchGoodsItemList()
                                        }}
                                        showingRow={goodsItems.length}
                                        currentPage={page}
                                        pageCount={totalPage}
                                        totalElement={totalElement}/>
                                </Col>
                                <Col className="p-3 me-0 mt-1 text-right" md={2}>
                                    <Button
                                        className="d-inline-block"
                                        size="sm"
                                        variant="success"
                                        onClick={async (e) => {
                                            e.preventDefault()
                                            await this.fetchGoodsItemList(true)
                                        }}
                                    >
                                        {label.DownloadExcel}&nbsp;&nbsp;<FontAwesomeIcon icon={faFileExcel}/>
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </>
        );
    }
}
// export default Object.assign(GoodsInfoPage, {ENDPOINT : "/goodsInfo"})

const ENDPOINT = "/stocks"
const TITLE = label.Stock
const PAGE = {ENDPOINT: ENDPOINT, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(StockInfoPage, PAGE)


